import { AlertCircle } from 'lucide-react'

import { Badge } from './badge'

interface CardErrorBadgeProps {
  dataTestId?: string
}

/** Shared top-left error pill for cinematic audience and study lobby cards. */
export function CardErrorBadge({ dataTestId }: CardErrorBadgeProps) {
  return (
    <Badge
      variant="destructive"
      data-testid={dataTestId}
      className="bg-destructive/60 hover:bg-destructive/60 backdrop-blur-sm text-white border-0 rounded-full h-7 w-7 p-0 flex items-center justify-center shadow-sm"
      aria-label="Error"
    >
      <AlertCircle className="h-3.5 w-3.5" />
    </Badge>
  )
}
